<template>
  <div
    v-if="model?.closest_due_task?.priority_level"
    class="flex w-full items-center justify-start gap-x-1"
  >
    <icon-base
      height="15"
      width="15"
      view-box="-1 0 15 15"
      :class="
        prioritiesIconsMap[
          model.closest_due_task
            .priority_level as keyof typeof prioritiesIconsMap
        ].class
      "
      :icon="
        prioritiesIconsMap[
          model.closest_due_task
            .priority_level as keyof typeof prioritiesIconsMap
        ].icon
      "
    />
    <span class="text-headline">
      {{ capitalize(model.closest_due_task.priority_level) }}
    </span>
  </div>
</template>

<script setup lang="ts">
import capitalize from "lodash/capitalize";

import { prioritiesIconsMap } from "@/helpers/constants/communicationLogs";

import IconBase from "@/components/ui/IconBase.vue";

import type { ApplicationDueTask } from "@/models/applications";

defineProps<{
  model?: { closest_due_task: ApplicationDueTask };
}>();
</script>
